"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastDailyReset = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
// Get the most recent "daily reset" timestamp, or midnight if the space has none
function getLastDailyReset(space, now) {
    if (now === undefined) {
        now = moment_timezone_1.default.tz(space.time_zone);
    }
    // TODO: Fetch the last actual daily OR max-dwell reset with the `source` query string param(s)?
    var lastDailyReset = space.daily_reset
        ? moment_timezone_1.default.tz(space.daily_reset, 'HH:mm', space.time_zone)
        : moment_timezone_1.default.tz(space.time_zone).startOf('day');
    // If this reset happens after "now", back it up a day
    while (lastDailyReset.valueOf() > now.valueOf()) {
        lastDailyReset.subtract(1, 'day');
    }
    return lastDailyReset;
}
exports.getLastDailyReset = getLastDailyReset;
//# sourceMappingURL=index.js.map